var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input',_vm._b({staticClass:"input-money",attrs:{"value":_vm.value,"type":'tel',"inputmode":'decimal',"autocomplete":'off',"placeholder":_vm.currencySymbol,"maxlength":(8 + _vm.currencySymbol.length).toString(),"mask-opts":{
    showMaskOnFocus: false,
    showMaskOnHover: false,
    placeholder: _vm.currencySymbol,
    regex: _vm.regexInput,
  }},on:{"input":_vm.onInput}},'base-input',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }